import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { LicenseInfo } from '@mui/x-license';
import { AdapterDateFns } from '@mui/x-date-pickers-pro/AdapterDateFnsV3';
import { LocalizationProvider } from '@mui/x-date-pickers-pro';
import { ToastContainer } from 'react-toastify';

import './rum';
import httpService from './services/httpService';
import { appTheme } from './assets/theme';
import ErrorBoundary from './components/Errors/ErrorBoundary';
import AppHeader from './components/Headers/AppHeader';
import AllRoutes from './routes/allRoutes';

import './assets/CSS/reactToastify.css';

LicenseInfo.setLicenseKey('2273394307a5f172e0bb835d931a9b3cTz05MTI2OSxFPTE3NDgxNzQyMjMwMDAsUz1wcmVtaXVtLExNPXN1YnNjcmlwdGlvbixLVj0y');

const App = (): React.JSX.Element => {
    const navigate = useNavigate();

    const [isAxiosSetup, setIsAxiosSetup] = useState(false);

    if (!isAxiosSetup) {
        httpService.setupInterceptors(navigate);
        setIsAxiosSetup(true);
    }

    return (
        <ThemeProvider theme={appTheme}>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
                <ErrorBoundary>
                    <CssBaseline enableColorScheme />
                    <ToastContainer position='bottom-center' theme='colored' />
                    <AppHeader />
                    <div className='main-container'>
                        <AllRoutes />
                    </div>
                </ErrorBoundary>
            </LocalizationProvider>
        </ThemeProvider>
    );
};

export default App;
